// There is a quirk with Emotion and using raw CSS in GlobalStyles where the
// first style in this block will be skipped/missed, so by adding the `body`
// declaration here, we can ensure the first font listed is applied correctly.
const fonts = `
  body {
    font-family: 'inter-regular', sans-serif;
  }
  @font-face {
    font-family: 'inter-medium';
    src: url('/assets/fonts/Inter-Medium.woff2') format('woff2'),
    url('/assets/fonts/Inter-Medium.woff') format('woff'),
    url('/assets/fonts/Inter-Medium.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'inter-regular';
    src: url('/assets/fonts/Inter-Regular.woff2') format('woff2'),
    url('/assets/fonts/Inter-Regular.woff') format('woff'),
    url('/assets/fonts/Inter-Regular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'inter-semibold';
    src: url('/assets/fonts/Inter-SemiBold.woff2') format('woff2'),
    url('/assets/fonts/Inter-SemiBold.woff') format('woff'),
    url('/assets/fonts/Inter-SemiBold.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'ibm-plex-mono-medium';
    src: url('/assets/fonts/IBMPlexMono-Medium.woff2') format('woff2'),
    url('/assets/fonts/IBMPlexMono-Medium.woff') format('woff'),
    url('/assets/fonts/IBMPlexMono-Medium.eot') format('embedded-opentype');
    font-weight: normal;
    font-style: normal;
  }
`;

export default fonts;
